import { _PdfAlgorithms } from './x509-algorithm';
import { _PdfUniqueBitString } from './x509-bit-string-handler';
var _PdfPublicKeyInformation = /** @class */ (function () {
    function _PdfPublicKeyInformation(algorithms, publicKey) {
        if (algorithms && publicKey) {
            this._algorithms = algorithms;
            this._publicKey = publicKey;
        }
    }
    _PdfPublicKeyInformation.prototype._fromAbstractSyntax = function (abstractSyntaxSequence) {
        var sequence = abstractSyntaxSequence._getSequence();
        if (!Array.isArray(sequence) || sequence.length !== 2) {
            throw new Error('Invalid length in sequence');
        }
        var algorithms = new _PdfAlgorithms()._getAlgorithms(sequence[0]);
        var publicKey = new _PdfUniqueBitString()._fromAbstractSyntaxOctets(sequence[1]._getValue());
        return new _PdfPublicKeyInformation(algorithms, publicKey);
    };
    _PdfPublicKeyInformation.prototype._getPublicKeyInformation = function (obj) {
        if (obj instanceof _PdfPublicKeyInformation) {
            return obj;
        }
        if (obj && obj._getSequence()) {
            return this._fromAbstractSyntax(obj);
        }
        return undefined;
    };
    return _PdfPublicKeyInformation;
}());
export { _PdfPublicKeyInformation };
